export default __webpack_public_path__ + "media/images/ui-bg_flat_0_aaaaaa_40x100-87cb7e52186e50c5be101b369138c5b2.png";